import template from './terms-of-service.tpl.pug';

class TermsOfServiceController {
    /* @ngInject */
    constructor($state, configuration) {
        this.$state = $state;
        this.configuration = configuration;
    }

    $onInit() {
        this.salesEmail = this.configuration.salesEmail;
        this.landingUrl = this.$state.href('landing');
    }
}

export default {
    selector: 'dbLTermsOfService',
    template: template(),
    controller: TermsOfServiceController
};



// WEBPACK FOOTER //
// ./src/legal/scene/terms-of-service/terms-of-service.cmpt.js